export const TABLETTES = [
  {
    id: "fourree-noir",
    name: "Tablette Chocolat Au Lait ",
    category: "Tablette fourrée",
    type: "fourree",
    price: 12,
    description: "",
    image: "/images/tablettes/fourre/tablette_aulait_fourre_pistache_kounefe.jpg",
  },
  {
    id: "fourree-gold",
    name: "Tablette Chocolat Blanc",
    category: "Tablette fourrée",
    type: "fourree",
    price: 12,
    description: "",
    image: "/images/tablettes/fourre/tablette_gold_fourre_pistache_kounefe.jpg",
  },
  {
    id: "fourree-ruby",
    name: "Tablette Chocolat Ruby",
    category: "Tablette fourrée",
    type: "fourree",
    price: 12,
    description: "",
    image: "/images/tablettes/fourre/tablette_ruby_fourre_pistache_kounefe.jpg",
  },

  {
    id: "garnie-fruits-secs",
    name: "Tablette chocolat RUBY ",
    category: "Tablette garnie",
    type: "garnie",
    price: 10,
    description: "",
    image: "/images/tablettes/garnie/tablette_garnie_ruby.jpg",
  },
  {
    id: "garnie-amandes",
    name: "Tablette chocolat AU LAIT ",
    category: "Tablette garnie",
    type: "garnie",
    price: 10,
    description: "",
    image: "/images/tablettes/garnie/tablette_garnie_aulait.jpg",
  },
  {
    id: "garnie-cafe",
    name: "Tablette chocolat Noir ",
    category: "Tablette garnie",
    type: "garnie",
    price: 10,
    description: "",
    image: "/images/tablettes/garnie/tablette_garnie_noir.jpg",
  },
];